// extracted by mini-css-extract-plugin
export var box = "_2g-2";
export var checkboxControl = "_2g-0";
export var checkboxRow = "_2g-a";
export var checked = "_2g-3";
export var descriptionSpacer = "_2g-c";
export var disabled = "_2g-4";
export var icon = "_2g-8";
export var input = "_2g-1";
export var labelSpacer = "_2g-b";
export var large = "_2g-7";
export var medium = "_2g-6";
export var small = "_2g-5";
export var text = "_2g-9";